import React from 'react';
import { Col, Row } from '../RowCol';
import Spacer from '../Spacer';
import { Category, RoundState } from '../../pages/Game/Game';
import CategorySquare from './CategorySquare';
import DollarSquare from './DollarSquare';

type Props = {
	categories: Category[];
	levels: number[];
	roundState: RoundState;
	selectQuestion: (categoryIndex: number, levelIndex: number) => void;
}

const BigBoard: React.FC<Props> = ({
	categories,
	levels,
	roundState,
	selectQuestion,
}) => {
	return (
		<Row>
			{categories.map((category, categoryIndex) => (
				<React.Fragment
					key={categoryIndex}
				>
					<Col>
						<CategorySquare
							name={category.name}
							author={category.author}
						/>
						<Spacer vertical={15} />
						{levels.map((level, levelIndex) => (
							<React.Fragment
								key={level}
							>
								<DollarSquare
									level={level}
									isOpen={roundState[categoryIndex][levelIndex]}
									onClick={() => selectQuestion(categoryIndex, levelIndex)}
								/>

								{levelIndex < levels.length - 1 && (
									<Spacer vertical={10} />
								)}
							</React.Fragment>
						))}
					</Col>
					{categoryIndex < categories.length - 1 && (
						<Spacer horizontal={10} />
					)}
				</React.Fragment>
			))}
		</Row>
	);
};

export default BigBoard;
